// Shared Reconciliation row filter (search text + date range). Used by the
// Reconciliation lists AND the allocation windows, so allocating only offers
// rows that match what you've filtered to (user 2026-10-14).

const rowDate = (r) => r.transaction_date || r.posting_date || r.value_date || '';

export function makeReconRowFilter({ search, fromDate, toDate } = {}) {
  const q = (search || '').trim().toLowerCase();
  const fromDt = fromDate || '';
  const toDt = toDate || '';
  const inDateRange = (dStr) => {
    const d = String(dStr || '').slice(0, 10);
    if (!d) return true;
    if (fromDt && d < fromDt) return false;
    if (toDt && d > toDt) return false;
    return true;
  };
  const matchesQ = (r) => {
    if (!q) return true;
    return [
      r.reference, r.loan_id, r.description, r.notes,
      r.investor_name, r.investor_id, r.bank_description,
      r.transaction_type, r.amount, rowDate(r),
    ].some(v => String(v ?? '').toLowerCase().includes(q));
  };
  return (r) => matchesQ(r) && inDateRange(rowDate(r));
}

export const reconFiltersActive = ({ search, fromDate, toDate } = {}) =>
  Boolean((search || '').trim() || fromDate || toDate);
